import { Record } from 'immutable';

const ShippingMethodDefaults = {
  id: null,
  address_required: null,
  title: null,
  subtitle: null,
  price_text: null
};

export default class ShippingMethod extends Record(ShippingMethodDefaults) {}



// WEBPACK FOOTER //
// banquet/models/ShippingMethod.js